import React, { useState } from "react";
import "antd/dist/antd.css";
import { Layout, Row, Col, Card, Input, Select, Button, message } from "antd";
import { ApiRoutes } from "../../../utils/Config/ApiRoutes";
import CreateApiService from "../../../utils/Config/LaravelService";
import { LoadingOutlined, PlusOutlined  } from "@ant-design/icons";

const { Option } = Select;

const AddEmployee = (props) => {
  const query = new URLSearchParams(props.location.search);
  // const lan = query.get("lan") ?? "EN";
  const csrf_test_name = query.get("token");
  let phoneCode = "";

  const [values, setValues] = useState({
    cityName: "",
    countryId: "",
    stateId: "",
    cityId: ""
  });
  const [errors, setErrors] = useState({
    cityName: "",
    countryId: "",
    stateId: "",
    cityId: ""
  });
  const [isCountryListLoading, setIsCountryListLoading] = useState(false);
  const [isStateListLoading, setIsStateListLoading] = useState(false);
  const [isCityListLoading, setIsCityListLoading] = useState(false);
  const [countryListData, setCountryListData] = useState([]);
  const [stateListData, setStateListData] = useState([]);
  const [cityListData, setCityListData] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  React.useEffect(() => {
    getCountryList();
    // eslint-disable-next-line
  }, []);

  const handleInputChange = async (e) => {
    if (e.target.type === "text") {
      if (e.target.name === "countryId") {
        let value = e.target.value;
        for (let x in countryListData) {
          if (countryListData[x].countryId === value) {
            phoneCode = countryListData[x].phoneCode;
          }
        }
        setValues({
          ...values,
          [e.target.name]: e.target.value,
          //   cityName: selectedCity,
          phoneCode: phoneCode
        });
      }
      if (e.target.name === "cityId") {
        const selectedCity = cityListData.find(
          (item) => item.cityId === e.target.value
        )?.cityName;
        setValues({
          ...values,
          [e.target.name]: e.target.value,
          cityName: selectedCity
        });
        setErrors({ ...errors, [e.target.name]: "" });
        if (selectedCity) {
          setIsFormValid(true);
        } else {
          setIsFormValid(false);
        }
      } else {
        setValues({ ...values, [e.target.name]: e.target.value });
        setIsFormValid(false);
      }
    }
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const getCountryList = async () => {
    try {
      setIsCountryListLoading(true);
      const formData = new FormData();
      formData.append("csrf_test_name", csrf_test_name);
      
      const res = await CreateApiService.post(`${ApiRoutes.COUNTRY_LIST.service}${ApiRoutes.COUNTRY_LIST.url}`, formData);
          console.log(res);
      const response = res.data;
  
      setIsCountryListLoading(false);
      if (res.status === 200) {
            console.log(response);;
        setCountryListData(response);
      }
    } catch (error) {
      message.error({
        content: error.message,
        duration: 2
      });
    }
  };

  const getStateList = async (countryId, stateId = "", cityId = "") => {
    try {
      setIsStateListLoading(true);
      const formData = new FormData();
      formData.append("countryId", countryId);
      formData.append("csrf_test_name", csrf_test_name);
      
      const res = await CreateApiService.post(`${ApiRoutes.STATE_LIST.service}${ApiRoutes.STATE_LIST.url}`, formData);
      const response = res.data;
      setIsStateListLoading(false);
      if (res.status === 200) {
        setCityListData([]);
        if (response[0] === "select State") {
          setStateListData([]);
        } else {
          setStateListData(response);
        }
        if (cityId) {
          getCityList(stateId, cityId);
        } else {
          setValues({
            ...values,
            countryId,
            stateId,
            cityId: "",
            phoneCode: phoneCode
          });
        }
      }
    } catch (error) {
      message.error({
        content: error.message,
        duration: 2
      });
    }
  };

  const getCityList = async (stateId, cityId = "",countryId=values.countryId) => {
    try {
      setIsCityListLoading(true);
      const formData = new FormData();
      formData.append("stateId", stateId);
      formData.append("countryId", countryId ?? values.countryId);
      formData.append("csrf_test_name", csrf_test_name);
      
      const res = await CreateApiService.post(`${ApiRoutes.CITY_LIST.service}${ApiRoutes.CITY_LIST.url}`, formData);
      const response = res.data;
      setIsCityListLoading(false);
      if (res.status === 200) {
        setCityListData(response);
        if (!cityId) setValues({ countryId:countryId ?? values.countryId, stateId, cityId });
      }
    } catch (error) {
      message.error({
        content: error.message,
        duration: 2
      });
    }
  };

  const handleAddCity = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
    if (
      e.target.value === "" ||
      e.target.value.trim() === "" ||
      e.target.value.length < 1
    ) {
      setErrors({ ...errors, cityName: "City Name Required" });
      setIsFormValid(false);
      return false;
    }
    setErrors({ ...errors, cityName: "" });
    setIsFormValid(true);
   
  };

  const handleSubmit = async () => {
    if (isFormValid) {
      try {
        setIsSubmitLoading(true);
        const formData = new FormData();
        for (let x in values) {
          if (x === "roleList") {
            for (let y in values[x]) {
              formData.append(`roleList[${y}]`, values[x][y]);
            }
          } else {
            formData.append(x, values[x]);
          }
        }
        formData.append("csrf_test_name", csrf_test_name);
        
        const res = await CreateApiService.post(`${ApiRoutes.ADD_CITY.service}${ApiRoutes.ADD_CITY.url}`, formData);
        const response = res.data;
        console.log(res,'res');
        setIsSubmitLoading(false);
        if (res.status === 200) {
          if (response.success === 1 || response.success === "1") {
            message.success(response.message);
            window.location.href = `${process.env.REACT_APP_LOCAL_URL}/partner/addCities?token=${csrf_test_name}`;
          } else {
            let error = response.message;
            if (typeof error === "object") {
              setErrors({ ...errors, ...error });
            } else {
              message.error({
                content: error,
                duration: 2
              });
            }
          }
        }
        setIsFormValid(true);
      } catch (error) {
        message.error({
          content: error.message,
          duration: 2
        });
      }
    }
  };

  return (
    <>
      <Layout className="m-10">
        <Row>
          <Col span={24}>
            <Col offset="4" span={16}>
              <Row>
                <Col span={24}>
                  <form
                    method="post"
                    ng-submit="addUserFun();"
                    className="addEmployeeForm"
                  >
                    <Card className="mb-1">
                      <Row gutter={[20, 20]}>
                        <Col span={12} className="mb-2">
                          {isCountryListLoading ? (
                            <LoadingOutlined />
                          ) : (
                            <>
                              <Select
                                name="countryId"
                                placeholder="Select Country"
                                value={values.countryId}
                                onChange={(value) => {
                                  console.log(value);
                                  handleInputChange({
                                    target: {
                                      type: "text",
                                      name: "countryId",
                                      value: value
                                    } 
                                  });
                                  value===13 ||value==="13"  ? getCityList("","",value) : 
                                  getStateList(value);
                                }}
                                style={{ width: "100%" }}
                              >
                                <Option value="">Select Country</Option>
                                {countryListData.map((item, key) => {
                                  return (
                                    <Option value={item.countryId} key={key}>
                                      {item.name}
                                    </Option>
                                  );
                                })}
                              </Select>
                              <div className="color-red mb-0">
                                {errors.countryId}
                              </div>
                            </>
                          )}
                        </Col>
                        <Col span={12} className="mb-2">
                          {isStateListLoading ? (
                            <LoadingOutlined />
                          ) : parseInt(values.countryId)!==13 ? (
                            <>
                              <Select
                                name="stateId"
                                placeholder="Select State"
                                value={values.stateId}
                                onChange={(value) => {
                                  handleInputChange({
                                    target: {
                                      type: "text",
                                      name: "stateId",
                                      value: value
                                    }
                                  });
                                  getCityList(value);
                                }}
                                style={{ width: "100%" }}
                              >
                                <Option value="">Select State</Option>
                                {stateListData.map((item, key) => {
                                  return (
                                    <Option value={item.stateId} key={key}>
                                      {item.stateName}
                                    </Option>
                                  );
                                })}
                              </Select>
                              <div className="color-red mb-0">
                                {errors.stateId}
                              </div>
                            </>
                           ) : ''}
                        </Col>
                      </Row>
                      <Row gutter={[20, 20]}>
                        <Col span={12} className="mb-2">
                          {isCityListLoading ? (
                            <LoadingOutlined />
                          ) : (
                            <>
                              <Select
                                name="cityId"
                                placeholder="Select City"
                                value={values.cityId}
                                onChange={(value) =>
                                  handleInputChange({
                                    target: {
                                      type: "text",
                                      name: "cityId",
                                      value: value
                                    }
                                  })
                                }
                                style={{ width: "100%" }}
                              >
                                <Option value="" selected="selected">
                                  Select City
                                </Option>

                                {cityListData.map((item, key) => {
                                  return (
                                    <Option value={item.cityId} key={key}>
                                      {item.cityName}
                                    </Option>
                                  );
                                })}
                                {cityListData && (
                                  <Option value=" ">
                                    <Button className="btn-transparent" icon={<PlusOutlined />}>Add New City</Button>
                                  </Option>
                                )}
                              </Select>
                              <div className="color-red mb-0">
                                {errors.cityId}
                              </div>
                            </>
                          )}
                        </Col>
                        {values.cityId && (
                          <Col span={12} className="mb-2">
                            <Input
                              name="cityName"
                              placeholder="Enter City Name"
                              value={values.cityName}
                              onChange={(e) => handleAddCity(e)}
                              className='addCityField fw-600'
                              autoFocus 
                            />
                            <div className="color-red mb-0">
                              {errors.cityName}
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Card>
                    <Row>
                      <Col span={24} className="text-right">
                        <Button
                          onClick={() =>
                            (window.location.href = `${process.env.REACT_APP_LOCAL_URL}/partner/addCities?token=${csrf_test_name}`)
                          }
                          type="dark"
                        >
                          {" "}
                          Cancel{" "}
                        </Button>
                        <Button
                          type="primary"
                          onClick={handleSubmit}
                          loading={isSubmitLoading}
                          disabled={!isFormValid || isSubmitLoading}
                          className="ml-2"
                        >
                          {"Submit"}
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </Col>
              </Row>
            </Col>
          </Col>
        </Row>
      </Layout>
    </>
  );
};
export default AddEmployee;
